__webpack_require__.p = "https://smartdl.lenovo.com.cn/frontend/browser/pcm-ai-stick/";